/**
 * PWA concerns kept out of the app/auth logic: service-worker registration.
 *
 * There is deliberately no "Add to Home Screen" affordance — the app ships as a
 * native wrapper, and `beforeinstallprompt` is Chromium-only anyway. Nothing
 * listens for that event, so the browser's own install UI is the only one.
 */

import { isNativeWebView } from './platform.js';

export function initPwa() {
  // Service worker — production only, so HMR is not shadowed by a cached shell.
  // Skipped inside a native WebView: there the shell is already local, so the
  // cache would buy nothing and could serve a stale one after an app update
  // (and a `capacitor://` origin can't register a worker in the first place).
  // Offline still works either way — content lives in IndexedDB, not this cache.
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && !isNativeWebView()) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .catch((err) => console.error('[SW] registration failed:', err));
    });
  }
}
